import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SeeOnMapModal } from "../../../components/modals/SeeOnMapModal";
import { SelectCustom } from "../../../components/ui/SelectCustom";
import { formatPrice, formatTimestampNew } from "../../../helpers";
import { NotificationModel } from "../../../components/modals/NotificationModel";
import { apiUrl } from "../../../data/constants";
import { trackFunnel } from "../../../helpers/analytics";

export const Course = ({ group, closest = null, bookOnsite }) => {
  const courseState = useSelector((state) => state.courses);

  const [internal_id, setInternal_id] = useState(
    group?.schedules[0]?.internal_id
  );
  const [selectedCourse, setSelectedCourse] = useState(group?.schedules[0]);
  const [seeOnMapModalOpen, setSeeOnMapModalOpen] = useState(false);

  const [notificationModelState, setNotificationModelState] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const course = group?.schedules?.find(
      (course) => course?.internal_id === internal_id
    );
    setSelectedCourse(course);
  }, [internal_id]);

  const ifLessTen = (val) => {
    if (String(val).length < 2) {
      return `0${val}`;
    } else {
      return val;
    }
  };

  const availableDatesOptions = group?.schedules?.map((course) => {
    return {
      value: course?.internal_id,
      label: group?.center?.partner
        ? `${formatTimestampNew(+course?.start_date)}, ${ifLessTen(
            new Date(course?.start_date * 1000).getHours()
          )}:${ifLessTen(new Date(course?.start_date * 1000).getMinutes())}`
        : formatTimestampNew(+course?.start_date),
    };
  });

  const handleBookNow = async (id) => {
    try {
      let fetchUrl = `${apiUrl}saleforce-bookingAllowed?code=${selectedCourse.scheduled_course_id}`;

      const response = await fetch(fetchUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      if (result.response.bookingAllowed) {
        trackFunnel("course_selected", { course_name: selectedCourse && selectedCourse.name, price: selectedCourse && selectedCourse.price_online, internal_id: internal_id });
        navigate(`/booking/${internal_id}?step=1`);
      } else {
        trackFunnel("course_soldout", { internal_id: internal_id });
        setNotificationModelState(true);
        setNotificationMessage(
          "Course is fully booked and booking is not allowed"
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      // Add user feedback here (toast, alert, etc.)
    }
  };

  return (
    <div className="card-row">
      <div className="card-row--item items items-10">
        {group?.center?.name != "Virtual" ? (
          <div className="laction-info">
            {closest && (
              <div className="location-text">Closest to {closest}</div>
            )}
            <div className="miles location-text">
              {group?.center?.distance ? (
                <span>
                  {(Number(group?.center?.distance) * 0.62137119).toFixed(2) +
                    "miles"}
                </span>
              ) : (
                <span>unknown</span>
              )}
            </div>
          </div>
        ) : (
          <span></span>
        )}
        {/* {selectedCourse?.name} */}
        <h4 className="heading-4 heading-4-sm">{group?.center?.name}</h4>
        {group?.center?.delivered_by ? (
          <p className="def-text-1 color-text--600">
            Delivered by our training partner{" "}
            <span className="fw-600">{group?.center?.delivered_by}</span>
            {selectedCourse?.accreditation
              ? ` · ${selectedCourse.accreditation} accredited`
              : ""}
          </p>
        ) : null}
        {group?.center?.name !== "Virtual" ? (
          <p>
            {group?.center?.full_address ||
              `${group?.center?.address_line_1}, ${group?.center?.address_line_3}`}
            {/* {group?.center?.name},  */}
            {/* {group?.center?.address_line_1},{" "}
          {group?.center?.address_line_3} */}
          </p>
        ) : (
          <p className="def-text-1 color-text--600">
            <span className="fw-600">Live instructor-led training</span> via
            Zoom video link &mdash; join from anywhere
          </p>
        )}
        {group?.center?.name !== "Virtual" ? (
          <a
            href="#"
            style={{ color: "#09983F" }}
            onClick={(e) => {
              e.preventDefault();
              setSeeOnMapModalOpen(true);
            }}
          >
            See On Map
          </a>
        ) : (
          <span></span>
        )}
        <div className="form-group">
          <label className="form-group-title">Pick start date</label>
          <div
            className="select-shadow-wrapp"
            key={`${group?.center?.name}` || "date"}
          >
            <SelectCustom
              options={availableDatesOptions}
              onSelect={(value) => setInternal_id(value)}
            />
          </div>
        </div>
      </div>

      <div className="card-row--item lightcard justify-content-end items items-10">
        <div className="flex-option">
          <h6 className="def-text-1 font-700">Reserve your seat</h6>
          {(() => {
            const space = Math.floor(Number(selectedCourse?.space));
            if (!Number.isFinite(space) || space <= 0) return null;
            if (space > 5)
              return <p className="color-text--success">Spaces available</p>;
            return (
              <p
                className={
                  space <= 3 ? "seats-left--urgent" : "color-text--success"
                }
              >
                Only <span>{space}</span> seat{space === 1 ? "" : "s"} left
              </p>
            );
          })()}
        </div>
        <h3 className="heading-3 pt-16">
          £{formatPrice(selectedCourse?.price_online)}
          <span className="text-default"> (inc VAT)</span>
        </h3>
        {Number.isFinite(Number(selectedCourse?.price_online)) &&
        Number(selectedCourse?.price_online) > 0 ? (
          <p
            className="def-text-1"
            style={{ marginTop: "-4px", opacity: 0.75 }}
          >
            £{(Math.round((Number(selectedCourse.price_online) / 1.2) * 100) / 100).toFixed(2)}{" "}
            ex VAT
          </p>
        ) : null}
        {selectedCourse?.price_window &&
        selectedCourse?.base_price_online > selectedCourse?.price_online ? (
          <p className="def-text-1">
            <span style={{ textDecoration: "line-through", opacity: 0.6 }}>
              £{formatPrice(selectedCourse?.base_price_online)}
            </span>{" "}
            <span className="color-text--success fw-600">
              {selectedCourse.price_window === "early_bird"
                ? "Early-bird price"
                : "Last-minute price"}
            </span>
          </p>
        ) : null}
        {!group?.center?.partner ? (
          // <Link
          //   to={`/booking/${internal_id}?step=1`}
          //   className="btn btn-success btn--md radius-5 ttu"
          // >
          //   Book now
          // </Link>
          <button
            onClick={() => handleBookNow(internal_id)}
            className="btn btn-success btn--md radius-5 ttu"
          >
            Book Now
          </button>
        ) : (
          <button
            className="btn btn-success-outline btn--md radius-5 ttu"
            onClick={(e) => {
              e.preventDefault();
              bookOnsite && bookOnsite();
            }}
          >
            Book onsite
          </button>
        )}
      </div>

      {notificationModelState && (
        <NotificationModel
          open={notificationMessage}
          setOpen={setNotificationMessage}
          message={notificationMessage}
        />
      )}

      {seeOnMapModalOpen ? (
        <SeeOnMapModal
          group={group}
          close={() => {
            setSeeOnMapModalOpen(false);
          }}
        />
      ) : null}
    </div>
  );
};
